import { Popover, Transition } from "@headlessui/react";
import { Fragment, useContext, useState } from "react";
import { Context } from "../../context/Context";
import { handleBackgroundColor } from "../../utils/update.utils";
export default function ColorPicker() {
  const { state, setState } = useContext(Context);
  const [customColor, setCustomColor] = useState("");
  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <Popover.Button className="hover:shadow-lg w-14 h-14  rounded-md border    p-2 cursor-pointer focus:border-indigo-400 outline-none transition transition-duration-300 ease-out ">
            <div className="w-full h-full ri-palette-fill text-xl flex items-center justify-center text-gray-400"></div>
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute z-10 w-72 -left-2 mx-auto mt-3 transform -translate-x-1/2   ">
              <div className="w-full bg-white h-60 rounded-lg shadow-2xl border   p-5 ">
                <div>
                  <span className="text-sm  text-gray-600 font-medium inline-block mt-1">
                    BACKGROUND
                  </span>
                  <div className="grid grid-cols-8 gap-1 w-full">
                    {state.theme.backgroundColor.map(({ value, ring }) => (
                      <button
                        onClick={(e) => {
                          setState(
                            handleBackgroundColor(value, state, "color")
                          );
                          close();
                        }}
                        key={value}
                        className={`outline-none w-6 h-6 rounded-full  focus:ring  ring-opacity-40 transition duration-300 filter drop-shadow-xl mt-3 ${value} ${ring}`}
                      ></button>
                    ))}
                  </div>
                  <span className="text-sm  text-gray-600 font-medium inline-block mt-5">
                    CUSTOM COLOR
                  </span>
                  <div className="w-full flex items-center justify-between mt-2">
                    <input
                      type="text"
                      className="w-auto h-10 border mr-2 focus:shadow-md transition duration-300 ease-in-out focus:border-indigo-300    outline-none rounded-md px-3 text-base text-gray-600 font-Blinker"
                      value={customColor}
                      onChange={(e) => setCustomColor(e.target.value)}
                      placeHolder="Eg : #151515"
                    />
                   

                    <button
                      disabled={
                        customColor?.includes(" ") || customColor === ""
                      }
                      onClick={() => {
                        setState(
                          handleBackgroundColor(customColor, state, 'custom')
                        );
                        close();
                      }}
                      className="ri-check-fill disabled:bg-indigo-500 w-10 h-10 rounded-md  text-white bg-indigo-600 focus:ring ring-indigo-600 ring-opacity-40 transition duration-300 ease-in-out font-bold text-lg outline-none "
                    ></button>
                  </div>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
